<template>
    <v-content>
        <v-layout>
            <v-flex xs12 sm12 md12>
                <v-toolbar dark color="primary" extended></v-toolbar>
                <v-layout row pb-2>
                    <v-flex xs10 sm8 md6 lg4 offset-sm2 offset-md3 offset-xs1 offset-lg4>
                        <v-card class="card--flex-toolbar elevation-7">
                            <v-toolbar card prominent>
                                <v-toolbar-title class="body-2 grey--text">
                                    Iniciar Sesión
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn flat icon color="info" @click="openHelp = true">
                                  <v-icon>help</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-container>
                                <v-layout wrap justify-space-around align-center>
                                    <div>
                                    <img src="@/assets/tecnm.png" style="height: 100px">
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div class="hidden-sm-and-down">
                                    <img src="@/assets/logo.png" style="width: 100px">
                                    </div>
                                </v-layout>
                            </v-container>
                            <v-form v-model="valid" @submit.prevent="login()">
                              <v-card-text>
                                <v-snackbar
                                        :timeout="6000"
                                        :color="'red'"
                                        top
                                        v-model="snackbar"
                                        light
                                >
                                    {{ errMessage }}
                                    <v-btn flat @click.native="snackbar = false">Cerrar</v-btn>
                                </v-snackbar>
                                <v-text-field prepend-icon="person" name="login" label="Número de Control" type="text" v-model="user.username" :rules="usernameRules"></v-text-field>
                                <v-text-field prepend-icon="lock" name="password" label="NIP" id="password" type="password" v-model="user.password" :rules="passwordRules"></v-text-field>
                                <v-flex md10 sm10>
                                  <v-switch :label="`Mantener sesión iniciada`" v-model="user.rememberMe"></v-switch>
                                </v-flex>
                                <v-flex xs12 class="mt-3 mb-4">
                  <div class="cf-turnstile" :data-sitekey="turnstileSiteKey" data-callback="onTurnstileSuccess" data-expired-callback="onTurnstileExpired"></div>
                </v-flex>
                                <div v-if="turnstileError" class="red--text caption mt-1">No se pudo cargar la verificación de seguridad. Por favor recarga la página.</div>
                              </v-card-text>
                              <v-card-actions class="mt-2">
                                  <v-btn
                                      type="submit"
                                      color="primary"
                                      :loading="loading"
                                      :disabled="loading || !valid || !turnstileToken"
                                      block
                                      large>
                                      Entrar
                                  </v-btn>
                              </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
      <v-dialog v-model="openHelp" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card style="background-color: #fafafa">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="openHelp = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Respuestas a las preguntas frecuentes</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <v-layout>
              <v-flex md12>
                <section class="mb-12">
                  <h3>No puedo entrar al Portal</h3>
                  <p>Es un problema común que se puede presentar por alguna de las siguientes situaciones:</p>
                  <v-card outlined light class="pa-3 mb-4" elevation="1">
                    <p>
                      El NIP que introduces no es correcto. <br>
                      <b>Solución:</b> acude con tu coordinador para que te genere un nuevo NIP.
                    </p>
                  </v-card>
                  <v-card outlined light class="pa-3 mb-4" elevation="1">
                    <p>
                      Te encuentras de baja (por tener un especial, reprobar algún especial, baja temporal).<br>
                      <b>Solución:</b> acude al departamento de Servicios Escolares para pedir la activación de tu cuenta.
                    </p>
                  </v-card>
                </section>
                <section class="mb-12">
                  <h3>No puedo imprimir mi referencia bancaria</h3>
                  <v-card outlined light class="pa-3 my-4" elevation="1">
                    <p>Verifica que tus datos socioecónomicos estén completos.</p>
                  </v-card>
                  <v-card outlined light class="pa-3 my-4" elevation="1">
                    <p>Si estuviste dado de baja temporal pasa a Servicios Escolares para verificar tu estado como alumno.</p>
                  </v-card>
                </section>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-content>
</template>

<script>
  import { mapState } from 'vuex'
  import { AUTH_REQUEST } from '@/store/mutation-types'

  export default {
    name: 'LoginPage',
    data: () => ({
      valid: false,
      errMessage: '',
      usernameRules: [
        v => !!v || 'El número de control es requerido'
      ],
      passwordRules: [
        v => !!v || 'Es necesario escribas tu PIN'
      ],
      user: {
        username: '',
        password: '',
        rememberMe: false
      },
      snackbar: false,
      openHelp: false,
      turnstileToken: '',
      turnstileError: false
    }),
    mounted () {
      window.onTurnstileSuccess = (token) => {
        this.turnstileToken = token
      }
      window.onTurnstileExpired = () => {
        this.turnstileToken = ''
      }
      if (window.turnstile) {
        this.$nextTick(() => {
          window.turnstile.render(this.$el.querySelector('.cf-turnstile'), {
            sitekey: process.env.TURNSTILE_SITE_KEY,
            callback: (token) => { this.turnstileToken = token },
            'expired-callback': () => { this.turnstileToken = '' }
          })
        })
      } else {
        const script = document.createElement('script')
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
        script.async = true
        script.onerror = () => {
          this.turnstileError = true
        }
        document.head.appendChild(script)
      }
    },
    methods: {
      login: function () {
        this.snackbar = false
        this.$store.dispatch(AUTH_REQUEST, { ...this.user, cfTurnstileToken: this.turnstileToken })
          .then(() => {
            this.$router.push('/')
          })
          .catch(() => {
            if (window.turnstile) window.turnstile.reset()
            this.turnstileToken = ''
            this.snackbar = true
            this.errMessage = 'El No. de Control o NIP son incorrectos.'
          })
      }
    },
    computed: {
      ...mapState(
        {
          status: state => state.auth.status
        }),
      loading: {
        get () {
          return this.status === 'loading'
        }
      },
      turnstileSiteKey () {
        return process.env.TURNSTILE_SITE_KEY
      }
    }
  }
</script>

<style scoped>
  .card--flex-toolbar {
      margin-top: -65px;
  }
  .v-card.pa-3 p {
    margin-bottom: 0;
  }

  .mb-12 {
    margin-bottom: 48px !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue